
jQuery(function($) {
  
  if ($('body').hasClass('template-page')){
  var tabs = $('ul.tabs');
  tabs.each(function(i) {
    var tab = $(this).find('> li > a');
    tab.click(function(e) {
      var contentLocation = $(this).attr('href');
      if(contentLocation.charAt(0)=="\#") {
        e.preventDefault();
        tab.removeClass('active');
        $(this).addClass('active');
        $(contentLocation).show().addClass('active').siblings().hide().removeClass('active');


      }

    });

  });

  var impacttabs = $('ul.impacttabs');
  impacttabs.each(function(i) {
    var impacttab = $(this).find('> li > a');
    impacttab.click(function(e) {
      var contentLocation = $(this).attr('href');
      if(contentLocation.charAt(0)=="#") {
        e.preventDefault();
        impacttab.removeClass('active');
        $(this).addClass('active');
        $(contentLocation).show().addClass('active').siblings().hide().removeClass('active');
      }
    });
  });

   $(".tabs a[href="+window.location.hash+"]").click();
  }
});